
import { useTranslation } from 'react-i18next';

export default function ProcessSection() {
  const { t } = useTranslation();

  const steps = [
    {
      step: '01',
      titleKey: 'process_step1',
      titleEnKey: 'process_step1_en',
      descKey: 'process_step1_desc',
      icon: 'ri-chat-3-line',
      details: [
        'process_step1_detail1',
        'process_step1_detail2',
        'process_step1_detail3',
        'process_step1_detail4'
      ]
    },
    {
      step: '02',
      titleKey: 'process_step2',
      titleEnKey: 'process_step2_en',
      descKey: 'process_step2_desc',
      icon: 'ri-user-search-line',
      details: [
        'process_step2_detail1',
        'process_step2_detail2',
        'process_step2_detail3',
        'process_step2_detail4'
      ]
    },
    {
      step: '03',
      titleKey: 'process_step3',
      titleEnKey: 'process_step3_en',
      descKey: 'process_step3_desc',
      icon: 'ri-rocket-2-line',
      details: [
        'process_step3_detail1',
        'process_step3_detail2',
        'process_step3_detail3',
        'process_step3_detail4'
      ]
    },
    {
      step: '04',
      titleKey: 'process_step4',
      titleEnKey: 'process_step4_en',
      descKey: 'process_step4_desc',
      icon: 'ri-bar-chart-box-line',
      details: [
        'process_step4_detail1',
        'process_step4_detail2',
        'process_step4_detail3',
        'process_step4_detail4'
      ]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('process_title')}
          </h2>
          <p className="text-lg text-gray-600 mb-2">{t('process_subtitle')}</p>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('process_description')}
          </p>
        </div>

        <div className="relative">
          {/* Desktop Timeline */}
          <div className="hidden lg:block">
            <div className="flex items-center justify-between mb-16">
              {steps.map((step, index) => (
                <div key={index} className="flex flex-col items-center relative">
                  <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-lg mb-4 relative z-10">
                    {step.step}
                  </div>
                  {index < steps.length - 1 && (
                    <div className="absolute top-8 left-16 w-full h-0.5 bg-gradient-to-r from-blue-600 to-purple-600"></div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Process Cards */}
          <div className="grid lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-6 border border-gray-100 group">
                {/* Mobile Step Number */}
                <div className="lg:hidden w-12 h-12 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center text-white font-bold mb-4">
                  {step.step}
                </div>
                
                <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center mb-4 group-hover:bg-blue-100 transition-colors duration-200">
                  <i className={`${step.icon} text-blue-600 text-xl`}></i>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {t(step.titleKey)}
                </h3>
                <p className="text-sm text-blue-600 mb-4 font-medium">
                  {t(step.titleEnKey)}
                </p>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {t(step.descKey)}
                </p>
                
                <ul className="space-y-2">
                  {step.details.map((detailKey, detailIndex) => (
                    <li key={detailIndex} className="flex items-center text-sm text-gray-600">
                      <i className="ri-check-line text-green-500 mr-2 flex-shrink-0"></i>
                      {t(detailKey)}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              {t('process_team_title')}
            </h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              {t('process_team_desc')}
            </p>
            <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-600">
              <div className="flex items-center">
                <i className="ri-time-line text-blue-600 mr-2"></i>
                {t('process_response_time')}
              </div>
              <div className="flex items-center">
                <i className="ri-shield-check-line text-blue-600 mr-2"></i>
                {t('process_quality_guarantee')}
              </div>
              <div className="flex items-center">
                <i className="ri-customer-service-line text-blue-600 mr-2"></i>
                {t('process_dedicated_service')}
              </div>
              <div className="flex items-center">
                <i className="ri-refresh-line text-blue-600 mr-2"></i>
                {t('process_continuous_optimization')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
